/**
 * Input Abstraction — decouples game logic from bonkjs Input singleton.
 *
 * Local player: reads from bonkjs Input.getKey()
 * Remote player (multiplayer): reads from network-buffered key state
 *
 * All game logic files (aiming.ts, di.ts, phases.ts) accept an InputProvider
 * instead of calling Input.getKey() directly, enabling multiplayer input routing.
 */

import { Input } from 'bonkjs';

export interface InputProvider {
    getKey(key: string): boolean;
}

/** Default InputProvider that reads from the local bonkjs Input singleton. */
export const localInput: InputProvider = {
    getKey: (key: string) => Input.getKey(key),
};

/**
 * Network-buffered InputProvider for remote players in multiplayer.
 * Key states are set by incoming network messages.
 */
export class NetworkInput implements InputProvider {
    private keys = new Map<string, boolean>();

    setKey(key: string, pressed: boolean): void {
        this.keys.set(key, pressed);
    }

    getKey(key: string): boolean {
        return this.keys.get(key) ?? false;
    }

    /** Clear all key states (e.g. on turn change). */
    clear(): void {
        this.keys.clear();
    }
}
